<template>
  <div :class="['action-list', { 'is-block': isBlock }]">
    <div v-auth="`rechargeBtn`" class="action-item" @click="goTopUpHandle">
      <div class="action-icon top-up__icon">
        <svg-icon name="TopUp" class-name="action-icon__svg" />
      </div>
      <span>{{ $t('topUp') }}</span>
    </div>
    <div v-auth="`withdrawBtn`" class="action-item" @click="goWithdrawHandle">
      <div class="action-icon withdraw__icon">
        <svg-icon name="Withdraw" class-name="action-icon__svg" />
      </div>
      <span>{{ $t('withdrawTitle') }}</span>
    </div>
    <div v-auth="`transferBtn`" class="action-item" @click="goTransferHandle">
      <div class="action-icon transfer__icon">
        <svg-icon name="Transfer" class-name="action-icon__svg" />
      </div>
      <span>{{ $t('transferTitle') }}</span>
    </div>
  </div>
</template>

<script>
import { Toast } from 'mand-mobile'
export default {
  name: 'ActionList',
  components: {
    [Toast.name]: Toast
  },

  props: {
    isBlock: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    goTopUpHandle () {
      // 充值页面
      this.$store.commit('change_name', 'TopUp')
      this.$router.push({
        name: 'TopUpAdmin'
      })
    },
    goWithdrawHandle () {
      // 提现页面
      // Toast.failed('Not supported temporarily')
      this.$store.commit('change_name', 'Withdraw')
      this.$router.push({
        name: 'Withdraw'
      })
    },
    goTransferHandle () {
      // 去转账页面
      this.$router.push({
        name: 'Transfer'
      })
    }
  }
}
</script>

<style scoped lang="scss">
.action-list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;

  .action-item {
    font-size: 28px;
    color: #000;

    .action-icon {
      margin: auto auto 24px auto;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 96px;
      width: 96px;
      border-radius: 32px;
      overflow: hidden;
      color: #fff;

      .action-icon__svg {
        width: 60%;
        height: 60%;
        overflow: hidden;
      }
    }
  }

  &:not(.is-block) {
    .top-up__icon {
      background: linear-gradient(53deg, #dd9afe 16%, #c17dfe 95%);
      box-shadow: 0 12px 20px -6px #c17dfe;
    }

    .transfer__icon {
      background: linear-gradient(43deg, #32b6fd 13%, #59a8fc 91%);
      box-shadow: 0 12px 20px -6px #59a8fc;
    }

    .withdraw__icon {
      background: linear-gradient(47deg, #56d3cb 13%, #03d2bd 94%);
      box-shadow: 0 12px 20px -6px #03d2bd;
    }
  }

  &.is-block {
    margin-bottom: 40px;
    padding: 40px 72px;
    border-radius: 32px;
    box-shadow: 0 4px 16px 0 rgba(138, 149, 158, 0.2);

    .top-up__icon {
      background: rgb(244, 231, 255);
      color: rgb(196, 129, 254);
    }

    .transfer__icon {
      background: rgb(237, 246, 255);
      color: rgb(88, 168, 252);
    }

    .withdraw__icon {
      background: rgb(230, 255, 252);
      color: rgb(12, 210, 190);
    }
  }
}
</style>
